import axios from 'axios'

export default axios.create({
    baseURL: 'https://lppsecureapi02.lpn.co.th/api/SecureApi'
})
